<div class="box" tabindex="1">
  <ng-content></ng-content>
</div>
